import { DateTime } from 'luxon'

const MonthlyPlanIds = [550028, 550698]

export const TeamRespTransform = (data) => {
  return data.map(team => {
  	const isActive = new Date().getTime() <= new Date(team.trialExpiresAt).getTime()
    const trialExpiresAt = DateTime.fromISO(team.trialExpiresAt)
    return Object.assign(team, {
      adminHash: team.admins.reduce((acc, u) => {
        acc[u.email] = true
        return acc
      }, {}),
      editorHash: team.editors.reduce((acc, u) => {
        acc[u.email] = true
        return acc
      }, {}),
      planColor: team.subscription ? 'green' : 'blue',
      planStatus: team.subscription ? 
      	MonthlyPlanIds.includes(team.subscription.subscriptionPlanId)
      	? 'Monthly'
      	: 'Annually' 
      	: 'On 2-Week Free Trial',
      planType: team.subscription && MonthlyPlanIds.includes(team.subscription.subscriptionPlanId)
      	? 'monthly' : 'yearly',
      trial: {
      	isActive,
      	color: isActive ? 'yellow' : 'red',
      	message: isActive 
      	? `Your Trial will expire on ${trialExpiresAt.toLocaleString(DateTime.DATE_MED)}`
      	: `Your Trial has been expired on ${trialExpiresAt.toLocaleString(DateTime.DATE_MED)}`
      } 
    })
  })
}



// WEBPACK FOOTER //
// ./src/Transforms/Team.js